import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']

  connect() {
  }

  toggle() {
    if (!this.hasMenuTarget) {
      console.error('Menu target not found!')
      return
    }

    const menu = this.menuTarget

    if (menu.classList.contains('hidden')) {
      // Show the menu
      menu.classList.remove('hidden')
      menu.classList.add('block')
    } else {
      // Hide the menu
      menu.classList.add('hidden')
      menu.classList.remove('block')
    }
  }
}
